import i18n from '@/helpers/i18n'
import { ToastProgrammatic as Toast } from 'buefy'

export const ToastNotification = {
  install(Vue) {
    Vue.prototype.$success = function(msg) {
      if (!msg) {
        msg = i18n.instance().t('toast-notification-save-success')
      }
      return Toast.open({
        message: msg,
        type: 'is-success'
      })
    }
  }
}
